import { makeStyles } from '@mui/styles'
import * as React from 'react'

import { DialogTitle } from '../../primitives/Dialog'
import Flex from '../../primitives/Flex'
import Heading from '../../primitives/Heading'
import Icon, { Icons } from '../../primitives/Icon'

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
  heading: {
    wordBreak: 'break-all',
  },
})

const IconsMapping = {
  success: Icons.SUCCESS,
  info: Icons.INFO,
  error: Icons.ERROR_OUTLINE,
}

interface Props {
  handleClose: () => void
  type: 'success' | 'info' | 'error'
}

const SimpleDialogTitle: React.FC<React.PropsWithChildren<Props>> = ({ children, type, handleClose }) => {
  const classes = useStyles()

  return (
    <DialogTitle>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex horizontalSpacing="dense" alignItems="center">
          <Icon icon={IconsMapping[type]} color="primary.main" size="x-large" />
          <Heading is="h5" variant="small" className={classes.heading}>
            {children}
          </Heading>
        </Flex>
        <Icon icon={Icons.CLOSE} size="large" marginLeft="dense" onClick={handleClose} className={classes.pointer} />
      </Flex>
    </DialogTitle>
  )
}

export default SimpleDialogTitle
